const API_BASE = (process.env.REACT_APP_API_URL || "").replace("/graphql", "");

export interface TableInfo {
  table_id: number;
  table_name: string | null;
  branch_id: number;
  restaurant_id: number;
  restaurant_name: string;
  restaurant_logo: string | null;
  restaurant_url_name: string | null;
}

export interface AddProductItem {
  id: number;
  price: number;
  quantity?: number;
  size?: number | null;
  comments?: string;
  ingredients?: number[];
  ingredients_txt?: string;
  ingredients_opt?: number[];
}

export interface AddProductsPayload {
  guest_name: string;
  products: AddProductItem[];
}

export interface AddProductsResponse {
  success: boolean;
  order_id: number;
  created_product_ids: number[];
}

async function handleResponse<T>(res: Response): Promise<T> {
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.message || body.error || `Error ${res.status}`);
  }
  return res.json();
}

export const dineInApi = {
  getTableInfo: (token: string): Promise<TableInfo> =>
    fetch(`${API_BASE}/api/dine-in/${token}`).then((r) =>
      handleResponse<TableInfo>(r)
    ),

  addProducts: (
    token: string,
    payload: AddProductsPayload
  ): Promise<AddProductsResponse> =>
    fetch(`${API_BASE}/api/dine-in/${token}/add-products`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }).then((r) => handleResponse<AddProductsResponse>(r)),
};
